export const GET_CATEGORIES_MULTI = "GET_CATEGORIES_MULTI";
export const GET_CATEGORIES_MULTI_SUCCESS = "GET_CATEGORIES_MULTI_SUCCESS";
export const GET_CATEGORIES_MULTI_ERROR = "GET_CATEGORIES_MULTI_ERROR";

export const getCategoriesMulti = () => ({
  type: GET_CATEGORIES_MULTI
});
